import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { LoadPlans } from "../../actions";
import { RefreshCircleIcon } from "../../icon";
import { PlanModel, PlanType } from "../../models/plans.model";
import * as selector from "../../selectors/selectors";
import PlanCard from "../plans/plan-card.component";
import { appNote, tenureTexts } from "../shared/constants";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TierLoader from "../shared/loaders/tiers-loader.json";

interface IProps {
    IsSignUp?: boolean;
    IsManualPayment?: boolean;
    onSelectPlan: (data: { Plan: PlanModel, Tenure: string }) => void;
}

const SelectPlan = (props: IProps) => {
    const dispatch = useDispatch()
    const Plans: PlanModel[] = useSelector(selector.plans)
    const LoadingPlans: boolean = useSelector(selector.loadingPlans)
    const LoadingFeatures: boolean = useSelector(selector.loadingFeatures)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const { state } = useLocation();
    const [tenure, setTenure] = useState<number>(1);
    const handleTabChange = (event: any, tabs: any) => {
        if (tabs !== null) {
            setTenure(tabs)
        }
    }
    const getFilteredPlans = () => {
        if (tenure === 1) {
            return Plans.filter(x => !x.IsDeleted && (state.ProductType === x.Product) && x.Type === PlanType.TIER && x.YearlyPrice !== 0).filter(plan => (plan.SelectedOrganizations.length > 0 ? (plan.SelectedOrganizations as string[])?.includes(state.Organization.ID) : plan))
        } else {
            return Plans.filter(x => !x.IsDeleted && (state.ProductType === x.Product) && x.Type === PlanType.TIER).filter(plan => (plan.SelectedOrganizations.length > 0 ? (plan.SelectedOrganizations as string[])?.includes(state.Organization.ID) : plan))
        }
    };
    const filteredPlans = getFilteredPlans();

    useEffect(() => {
        LoadPlans(dispatch)
    }, [])
    return (
        <Grid container className=" w-130 ml-2 mr-2 h-85 paper-background  dialogue-shadow settings-paper-border br-4">
            {!state.IsAddonRecharge &&
                <div className={`w-fill pt-1 pr-2`}>
                    <Grid container className={` d-flex justify-flex-end  ${(IsMobileDevice && state.IsSignUp) ? 'pr-3' : ''} `}>
                        <ToggleButtonGroup value={[tenure]} exclusive className={`bg-color-secondary br-5 dialogue-shadow settings-paper-border`} onChange={handleTabChange}>
                            <ToggleButton value={1} size='small' className={`${tenure === 1 ? "plans-button-active plans-button" : "plans-button"} ${IsMobileDevice ? 'h2' : 'h4-regular'} butons-transform  br-6 b-none`}  > {tenureTexts.ANNUAL}</ToggleButton>
                            <ToggleButton value={2} size="small" className={`${tenure === 2 ? "plans-button-active plans-button" : "plans-button"} ${IsMobileDevice ? 'h2' : 'h4-regular'} b-none br-6 butons-transform`} style={{ marginLeft: '0.01rem' }}>{tenureTexts.MONTH}</ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>

                </div>
            }
            <Grid container direction="row" className={`mx-0 d-flex justify-center align-center h-p-82 o-y-scroll o-x-hidden`} >
                {LoadingPlans || LoadingFeatures ?
                    <Grid xl={3} md={6} sm={8} item className='my-2 mx-4'>
                        <AnimateLoader LoaderAnimation={TierLoader} style={{ maxWidth: "330px" }} className={"w-p-100"} />
                    </Grid>
                    : Plans.length > 0 ?
                        filteredPlans.length ? filteredPlans.map((x, i) =>
                            <Grid item >
                                <PlanCard key={i} {...x} DisplayYearlyPrice={tenure === 1} ShowAddOnOptions={false} OnClick={() => { props.onSelectPlan({ Plan: x, Tenure: tenure === 1 ? 'A' : 'M' }); (global as any).paymentID = ""; }} IsSignUp={props.IsSignUp} Index={i} IsMobileDevice={IsMobileDevice} />
                            </Grid>)
                            :
                            <span className="h3-regular">{appNote.NO_PLAN_AVAILABLE}</span>
                        : <div className="c-pointer" onClick={() => LoadPlans(dispatch)}>
                            <div className="d-flex">
                                <RefreshCircleIcon className="mx-auto" />
                            </div>
                            <div className="h4 mt-1">{appNote.CLICK_TO_REFRESH_PLANS}</div>
                        </div>
                }
            </Grid>
        </Grid >)
};

export default SelectPlan;